export const API_ID = 414121 // put your API id here
export const API_HASH = 'db09ccfc2a65e1b14a937be15bdb5d4b' // put your API hash here
// export const API_ID = 17349 // put your API id here
// export const API_HASH = '344583e45741c457fe1862106095a5eb' // put your API hash here



 